import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Yearly Revenue',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'orgs',
                },
              },
              subqueries: {
                orgs: {
                  filter: {
                    '=': [
                      {
                        '@^': 'parent',
                      },
                      {
                        '``': {
                          '@$': 'orgRecordId',
                        },
                      },
                    ],
                  },
                  target: 'ent:!org:!div',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          apr: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'expensesApr',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'revenueAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          feb: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'expensesFeb',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'revenueAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          jan: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'expensesJan',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'revenueAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          mar: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'expensesMar',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'revenueAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          organization: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    expensesApr: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!org',
                        inherit: '-',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '4/30/2026',
                          },
                          start: {
                            $date: '4/1/2026',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          expenseAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Expense',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          revenueAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Revenue',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!name',
                          },
                        },
                      },
                    },
                    expensesFeb: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!org',
                        inherit: '-',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '2/28/2026',
                          },
                          start: {
                            $date: '2/1/2026',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          expenseAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Expense',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          revenueAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Revenue',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!name',
                          },
                        },
                      },
                    },
                    expensesJan: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!org',
                        inherit: '-',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '1/31/2026',
                          },
                          start: {
                            $date: '1/1/2026',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          expenseAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Expense',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          revenueAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Revenue',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!name',
                          },
                        },
                      },
                    },
                    expensesMar: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!org',
                        inherit: '-',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '3/31/2026',
                          },
                          start: {
                            $date: '3/1/2026',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          expenseAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Expense',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          revenueAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Revenue',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!name',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              target: 'ent:!org:!div',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      apr: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'expensesApr',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'revenueAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      feb: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'expensesFeb',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'revenueAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      jan: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'expensesJan',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'revenueAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      mar: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'expensesMar',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'revenueAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      organization: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                expensesApr: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!org',
                    inherit: '-',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '4/30/2026',
                      },
                      start: {
                        $date: '4/1/2026',
                      },
                    },
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      expenseAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'Expense',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      revenueAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'Revenue',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    costType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!name',
                      },
                    },
                  },
                },
                expensesFeb: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!org',
                    inherit: '-',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '2/28/2026',
                      },
                      start: {
                        $date: '2/1/2026',
                      },
                    },
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      expenseAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'Expense',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      revenueAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'Revenue',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    costType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!name',
                      },
                    },
                  },
                },
                expensesJan: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!org',
                    inherit: '-',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '1/31/2026',
                      },
                      start: {
                        $date: '1/1/2026',
                      },
                    },
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      expenseAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'Expense',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      revenueAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'Revenue',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    costType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!name',
                      },
                    },
                  },
                },
                expensesMar: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!org',
                    inherit: '-',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '3/31/2026',
                      },
                      start: {
                        $date: '3/1/2026',
                      },
                    },
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      expenseAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'Expense',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      revenueAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'Revenue',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    costType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!name',
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'organization',
                  direct: {
                    '{}': {
                      name: 'Organization',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'jan',
                  direct: {
                    '{}': {
                      name: 'Jan',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'feb',
                  direct: {
                    '{}': {
                      name: 'Feb',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'mar',
                  direct: {
                    '{}': {
                      name: 'Mar',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'apr',
                  direct: {
                    '{}': {
                      name: 'Apr',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      apr: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'apr',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      feb: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'feb',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      jan: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'jan',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      mar: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mar',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      organization: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  target: 'ent:!org:!div',
                  selection: {
                    '{}': {
                      apr: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'expensesApr',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'revenueAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      feb: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'expensesFeb',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'revenueAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      jan: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'expensesJan',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'revenueAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      mar: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'expensesMar',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'revenueAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      organization: {
                        '@.': '!name',
                      },
                    },
                  },
                  subqueries: {
                    expensesApr: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!org',
                        inherit: '-',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '4/30/2026',
                          },
                          start: {
                            $date: '4/1/2026',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          expenseAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Expense',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          revenueAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Revenue',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!name',
                          },
                        },
                      },
                    },
                    expensesFeb: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!org',
                        inherit: '-',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '2/28/2026',
                          },
                          start: {
                            $date: '2/1/2026',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          expenseAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Expense',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          revenueAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Revenue',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!name',
                          },
                        },
                      },
                    },
                    expensesJan: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!org',
                        inherit: '-',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '1/31/2026',
                          },
                          start: {
                            $date: '1/1/2026',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          expenseAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Expense',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          revenueAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Revenue',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!name',
                          },
                        },
                      },
                    },
                    expensesMar: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!org',
                        inherit: '-',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '3/31/2026',
                          },
                          start: {
                            $date: '3/1/2026',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          expenseAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Expense',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          revenueAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'Revenue',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!name',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
